import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {Chat, IMessengerConnector} from "../../../types/all.type";
import {WebrtcService} from "../../../services/webrtc.service";
import {UserCall} from "../../../types/video.calls.type";

@Component({
  selector: 'app-stream-user-item',
  templateUrl: './stream-user-item.component.html',
  styleUrls: ['./stream-user-item.component.scss']
})
export class StreamUserItemComponent implements OnInit, AfterViewInit {
  @ViewChild('video', {read: ElementRef, static:false}) video: ElementRef;
  @Input() Service: IMessengerConnector;
  @Input() chat: Chat;
  @Input() user: UserCall;
  @Output() toggleMuteUser: EventEmitter<string> = new EventEmitter();

  constructor(
    private cd: ChangeDetectorRef,
    public webrtcService: WebrtcService,
  ) { }

  ngOnInit(): void {
    // this.cd.detach();

    this.toggleMuteUser.subscribe(() => {
      this.cd.detectChanges();
    })
  }
  ngAfterViewInit() {
    this.webrtcService.videoStreamInit(this.video.nativeElement, this.user);
  }
}
